import Vue from "vue";
import LoadScript from "vue-plugin-load-script";
import App from "./App.vue";
window.$ = require("jquery");
window.JQuery = require("jquery");
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import router from "./router";
import store from "./store";
// import ZoomOnHover from "vue-zoom-on-hover";
import VModal from "vue-js-modal";
// import VueClipboard from 'vue-clipboard2'
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";
import firebase from "firebase/app";
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import VueLoading from 'vuejs-loading-plugin'
 
// using default options
// Vue.use(VueLoading)
 
// overwrite defaults
Vue.use(VueLoading, {
  // dark: true, // default false
  text: 'Chargement', // default 'Loading'
  // customLoader: myVueComponent, // replaces the spinner and text with your own
  // classes: ['myclass'] // array, object or string
})

var firebaseConfig = {
  apiKey: "AIzaSyCMR1f6nAAD30njE0YtvTvyTvUT8tRsosU",
  authDomain: "giftstore-2020.firebaseapp.com",
  projectId: "giftstore-2020",
  storageBucket: "giftstore-2020.appspot.com",
  messagingSenderId: "61249501982",
  appId: "1:61249501982:web:be55914517a9d7a8dd270f",
  measurementId: "G-X3LHHG4KNF",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.use(Vuesax, {
  // options here
});

// Vue.use(VueClipboard)
// Vue.use(ZoomOnHover);

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueToast);

Vue.use(LoadScript);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
